import log from './log';

export async function hashEmail(email: string): Promise<string> {
    if (!email) return '';

    try {
        const encoder = new TextEncoder();
        const data = encoder.encode(email.toLowerCase().trim());
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    } catch (error) {
        log.scope('Email').error('Error hashing email', { error });
        return '';
    }
}
